/* FOMO — wymagana akceptacja regulaminu w koszyku (P24) */
(function () {
  if (window.__fomoTermsInit) return;
  window.__fomoTermsInit = true;

  var CB = '#fomo-terms-check';
  var WRAP = '[data-fomo-terms]';
  var LOCK_SEL = '.cart__dynamic-checkout-buttons, #checkout';

  function checkbox() { return document.querySelector(CB); }
  function isChecked() { var c = checkbox(); return !!(c && c.checked); }

  function apply() {
    var checked = isChecked();
    // główny przycisk „Realizuj zakup"
    var checkout = document.getElementById('checkout');
    if (checkout && !(checkout.dataset.cartEmpty === 'true')) {
      checkout.toggleAttribute('disabled', !checked);
    }
    // przyciski ekspresowe (Shop Pay / PayPal) — blokada wskaźnika
    document.querySelectorAll('.cart__dynamic-checkout-buttons').forEach(function (el) {
      el.classList.toggle('fomo-locked', !checked);
    });
    if (checked) hideError();
  }

  function showError() {
    var err = document.getElementById('fomo-terms-error');
    if (err) err.hidden = false;
    var w = document.querySelector(WRAP);
    if (w) w.classList.add('fomo-terms--error');
  }
  function hideError() {
    var err = document.getElementById('fomo-terms-error');
    if (err) err.hidden = true;
    var w = document.querySelector(WRAP);
    if (w) w.classList.remove('fomo-terms--error');
  }

  // zapis zgody na zamówieniu (atrybut koszyka)
  function recordConsent() {
    try {
      var d = new Date();
      var stamp = d.toLocaleString('pl-PL');
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: { 'Akceptacja regulaminu i polityki prywatności': 'Tak — ' + stamp } })
      });
    } catch (e) {}
  }

  // reakcja na zmianę checkboxa (delegacja — przeżywa przeładowania sekcji)
  document.addEventListener('change', function (e) {
    if (e.target && e.target.matches(CB)) {
      apply();
      if (e.target.checked) recordConsent();
    }
  });

  // twarda blokada kliknięć w checkout, gdy niezaznaczone (faza przechwytywania)
  document.addEventListener('click', function (e) {
    var hit = e.target.closest ? e.target.closest(LOCK_SEL + ', .shopify-payment-button') : null;
    if (!hit) return;
    if (!isChecked()) {
      e.preventDefault();
      e.stopPropagation();
      showError();
      var w = document.querySelector(WRAP);
      if (w) w.scrollIntoView({ block: 'center', behavior: 'smooth' });
    }
  }, true);

  // blokada wysłania formularza koszyka (Enter / submit)
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (form && form.getAttribute && form.getAttribute('action') && /\/cart/.test(form.getAttribute('action')) && !isChecked()) {
      e.preventDefault();
      showError();
    }
  }, true);

  // stan początkowy + po każdym przeładowaniu koszyka (Dawn podmienia HTML)
  function boot() { if (document.querySelector(WRAP)) apply(); }
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);

  // po przeładowaniu koszyka Dawn podmienia HTML — wymuś stan, ale z debounce (bez zacinania)
  var raf = null;
  var mo = new MutationObserver(function () {
    if (raf) return;
    raf = requestAnimationFrame(function () {
      raf = null;
      if (document.querySelector(WRAP)) apply();
    });
  });
  var target = document.getElementById('MainContent') || document.body;
  if (target) mo.observe(target, { childList: true, subtree: true });
})();
